import { AsyncPipe, NgIf, PercentPipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { MatRipple } from '@angular/material/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { RetailItemSale } from '../../../models/retail-item-sale';
import { HlCurrencyPipe } from '../../pipes/hl-currency.pipe';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-items-table',
  templateUrl: './items-table.component.html',
  standalone: true,
  imports: [
    NgIf,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    RouterLink,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    AsyncPipe,
    PercentPipe,
    HlCurrencyPipe,
    MatMenuModule
  ]
})
export class ItemsTableComponent {
  @Input() items: Observable<RetailItemSale[]>;

  @Input() set canEdit(value: boolean) {
    this._canEdit = value;
    if (value && !this._eposMode) {
      this.addColumn('actions');
    } else {
      this.removeColumn('actions');
    }
  }
  _canEdit = true;
  _eposMode = false;

  @Input() set eposMode(value: boolean) {
    this._eposMode = value;
    if (value) {
      this.displayedColumns = ['eposCompact', 'price'];
    } else {
      this.removeColumn('eposCompact');
    }
  }

  @Input() currencyRate = 1;
  @Input() currency = null;
  @Output() itemDeleteRequested = new EventEmitter<number>();
  @Output() itemEditRequested = new EventEmitter<RetailItemSale>();

  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  menuTopLeftPosition = { x: '0', y: '0' };

  displayedColumns: string[] = [
    'name',
    'quantity',
    'unit_price',
    'tax_rate',
    'price',
    'actions'
  ];

  private addColumn(columnName: string) {
    if (this.displayedColumns.includes(columnName)) {
      return;
    }
    this.displayedColumns.push(columnName);
  }

  private removeColumn(columnName: string) {
    this.displayedColumns = this.displayedColumns.filter(
      (column) => column !== columnName
    );
  }

  onRowClicked(row: RetailItemSale, event) {
    if (this._eposMode && this._canEdit) {
      // this.itemEditRequested.emit(row);
      // preventDefault avoids to show the visualization of the right-click menu of the browser
      event.preventDefault();

      // we record the mouse position in our object
      this.menuTopLeftPosition.x = event.clientX + 'px';
      this.menuTopLeftPosition.y = event.clientY + 'px';

      this.matMenuTrigger.menuData = { item: row };
      // we open the menu
      this.matMenuTrigger.openMenu();
    }
  }

  onRightClick(event) {}
}
